import "../styles/LoadingIndicator.css"

function LoadingIndicator() {
    return <div className="loading-spinner" />;
}

export default LoadingIndicator